export default [
  {
    id: 'match-fees',
    name: 'Match Fees',
  },
  {
    id: 'fine-payment',
    name: 'Fine Payment',
  },
  {
    id: 'registration',
    name: 'Registration',
  },
  {
    id: 'tournament',
    name: 'Tournament',
  },
  {
    id: 'uniform',
    name: 'Uniform',
  },
];
